import * as React from "react";

export type Direction = "ltr" | "rtl";

/**
 * Reads the current document direction and stays in sync when the language
 * switcher flips `dir` on <html>. Always returns "ltr" during SSR/hydration so
 * the server and client markup match.
 */
export function useDirection(): Direction {
  const [dir, setDir] = React.useState<Direction>("ltr");

  React.useEffect(() => {
    const read = () =>
      setDir(document.documentElement.getAttribute("dir") === "rtl" ? "rtl" : "ltr");
    read();
    const observer = new MutationObserver(read);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["dir"] });
    return () => observer.disconnect();
  }, []);

  return dir;
}
